export const phieuNhanHang = {
  sections: {
    list: { title: 'Goods Receipt Note' },
    detail: { title: 'Receipt Detail' },
    lines: 'Received Items',
    soKhops: 'Receiving Match',
  },
  titles: { add: 'Create Receipt', addNew: 'Add New' },
  placeholders: {
    ghiChu: 'Notes (e.g., missing packaging, defective)',
  },
  form: {
    codeAuto: 'Leave blank for auto code',
    trangThai: 'Status',
    sectionHeader: 'Receipt Information',
    sectionSummary: 'Receipt Summary',
    sectionLines: 'Received items',
    sectionMuaHang: 'Shipping & Purchasing Information',
    sectionLogistics: 'Logistics & Packing',
    tongSoLuongDat: 'Total expected',
    tongSoLuongNhan: 'Total received',
    tongThieu: 'Total short',
    tongThua: 'Total over',
    tongTienHang: 'Subtotal',
    tongSoMatHang: 'SKU count',
    maSp: 'SKU',
    tenSp: 'Item name',
    lineNote: 'Note',
    datHangNcc: 'Purchase order',
    nhaCungCap: 'Supplier',
    note: 'Voucher note',
    save: 'Save',
    chooseDatHangNcc: 'Select Purchase Order',
    openSourcePo: 'Choose a purchase order as source',
    datHangNccClear: 'Clear purchase order',
    datHangNccSearch: 'Search Purchase Order',
    datHangNccEmpty: 'No purchase orders found.',
    productSearch: 'Search product',
    lotRequired: 'Lot no. *',
    startTitle: 'Start a goods receipt',
    startHint: 'Pick how to create — we will prefill what we can.',
    pathFromPo: 'From purchase order',
    pathFromPoHint: 'Loads supplier and lines from the PO. Just adjust received qty.',
    pathIndependent: 'Independent receipt',
    pathIndependentHint: 'Pick a supplier, then add items with F3 — when there is no PO.',
    pathRecommended: 'Recommended',
    backToStart: 'Choose another way',
    receiveAll: 'Receive all',
    receiveAllHint: 'Set received qty = expected qty for every line',
    lineCount: '{count} lines',
    tuMuaHang: 'From purchasing',
    tuMuaHangHint: 'Created from the purchasing system — lines and quantities cannot be edited',
    emptyNeedSource: 'Choose a receipt source to continue.',
    emptyPickSupplier: 'Pick a supplier above, then add items with F3.',
    emptyFromPo: 'This PO has no lines.',
    emptyAddProduct: 'No items yet — search and add products to receive.',
    emptyF3Hint: 'Press F3 to search products quickly.',
  },
  aria: { columnPicker: 'Choose columns' },
  columns: {
    tongSoLuong: 'Total qty',
    tongTienHang: 'Total amount',
    canTraNCC: 'Payable to supplier',
    code: 'Receipt Code',
    chiNhanh: 'Branch',
    summary: 'Info',
    status: 'Status',
    ngayTao: 'Created at',
    ngayCapNhat: 'Updated at',
    maDatHang: 'PO Code',
    nhaCungCap: 'Supplier',
    ngayNhan: 'Received Date',
    maPhieuNhapKho: 'Stock-in voucher',
  },
  filter: {
    searchPlaceholder: 'By receipt code, PO code, supplier name',
    title: 'Filter',
    supplier: 'Supplier',
    datHangNcc: 'Purchase Order',
    trangThai: 'Status',
    chiNhanh: 'Branch',
    tuNgay: 'From date',
    denNgay: 'To date',
    fromDate: 'From date',
    toDate: 'To date',
    dateRangePlaceholder: 'Select date range',
    maVanChuyenAzl: 'AZL tracking code',
    maYcmh: 'Purchase request code (YCMH)',
    sortDir: 'Order',
    asc: 'Ascending',
    desc: 'Descending',
    all: 'All',
    reset: 'Reset',
    nccTreeAll: 'All suppliers',
    nccTreeSearch: 'Search suppliers',
    nccTreeEmpty: 'No suppliers',
    chiNhanhTreeAll: 'All branches',
    chiNhanhTreeSearch: 'Search branches',
    chiNhanhTreeEmpty: 'No branches',
  },
  fields: {
    code: 'Receipt Code',
    chiNhanh: 'Branch',
    maDatHang: 'PO Code',
    supplier: 'Supplier',
    ngayNhan: 'Received Date',
    ngayNhapMua: 'Purchase inbound date/time',
    status: 'Status',
    ghiChu: 'Notes',
    product: 'Product',
    productCode: 'Code',
    productName: 'Name',
    donViTinh: 'UoM',
    tyLeQuyDoi: 'Conversion rate',
    soLuongDat: 'Expected Qty',
    soLuongNhan: 'Actual Received',
    soLuongThieu: 'Short',
    soLuongThua: 'Over',
    chenhLech: 'Variance',
    maLo: 'Lot no.',
    hanSuDung: 'Expiry Date',
    donGia: 'Unit Price',
    thanhTien: 'Amount',
    lineGhiChu: 'Line Note',
    actions: 'Actions',
    nguoiNhan: 'Receiver',
    createdAt: 'Created On',
    soRef: 'REF No.',
    ngayDatHangThucTe: 'Actual order date',
    ngayPhatHangThucTe: 'Actual dispatch date',
    ngayVeKhoThucTe: 'Actual warehouse arrival date',
    tenNhanVienMuaHang: 'Purchasing staff',
    tenNhanVienYeuCau: 'Requesting staff',
    tongTheTich: 'Total volume (m³)',
    tongCanNang: 'Total weight (kg)',
    hinhThucVc: 'Shipping method',
    cont: 'Container',
    maVanChuyenNcc: 'Supplier tracking code',
    maVanChuyenAzl: 'AZL tracking code',
    maYcmh: 'Purchase request (YCMH)',
    maBaoGia: 'Quote code',
    ngayBaoGia: 'Quote created date',
    donViTinhMua: 'Purchase UoM',
    soLuongKhuyenMai: 'Bonus qty',
    tongSoLuongSanPham: 'Total product qty',
    soKien: 'Package qty',
    daiThung: 'Box length',
    rongThung: 'Box width',
    caoThung: 'Box height',
    theTichThung: 'M3/box',
    canNangThung: 'Kg/box',
    quyCachThung: 'Spec/box',
    canNangSanPham: 'Kg/item',
    theTichSanPham: 'M3/item',
  },
  status: {
    choNhan: 'Pending',
    daNhanXong: 'Received',
    daHuy: 'Cancelled',
    khac: 'Other',
  },
  filters: {
    hintSection: 'Goods Receipt Filters',
    hintBody: 'Filter by status, date, supplier or purchase order.',
  },
  menu: {
    openSupplierList: 'Suppliers (List)',
    createfromPhieuNhan: 'Create from Receipt',
  },
  actions: {
    exportFile: 'Export',
    addLine: 'Add Line',
    complete: 'Complete Receipt',
    cancelVoucher: 'Cancel Receipt',
    copy: 'Copy Receipt',
    dongY: 'Agree',
    importExcel: 'Import Excel',
    downloadTemplate: 'Download Template',
    exportOverview: 'Export Overview',
    exportDetail: 'Export Detail',
    createPhieuNhap: 'Create Purchase In',
    createPhieuNhan: 'Create Receipt',
  },
  messages: {
    loadError: 'Failed to load receipts.',
    noData: 'No receipts yet.',
    listSummary: 'Total: {count} receipts',
    createSuccess: 'Receipt created.',
    updateSuccess: 'Receipt updated.',
    deleteSuccess: 'Receipt deleted.',
    needLines: 'Please add at least one item.',
    exportSuccess: 'Excel downloaded.',
    importSuccess: 'Imported items from Excel.',
    completeSuccess: 'Receipt completed.',
    cancelVoucherSuccess: 'Receipt cancelled.',
    confirmCancelVoucher: 'Cancel receipt {name}? This cannot be undone.',
    confirmComplete: 'Complete receipt {name}? Lines can no longer be edited afterwards.',
    confirmCompleteWarn: 'This will create a purchase inbound voucher (NHAP_MUA) and increase stock.',
    confirmCompleteHint: 'Pick inbound date/time — defaults to the receipt date on the voucher.',
    notFound: 'Receipt not found.',
    confirmDelete: 'Delete receipt {name}?',
    nhanThuaWarning: 'Warning: received quantity exceeds ordered.',
    needDatHangNcc: 'Please select a purchase order.',
    orSupplier: 'or pick a supplier to create standalone',
    needSource: 'Please select a purchase order or a supplier.',
    checkRequiredFields: 'Please fill required fields.',
    sourcePoLoaded: 'Loaded {count} items from PO {code}.',
    sourcePoNotFound: 'No matching purchase order.',
    noLines: 'No items received yet.',
    needMaLo: 'Item "{code}" tracks expiry — enter lot no.',
    needHanSuDung: 'Item "{code}" tracks expiry — enter expiry date.',
    needLotCount: '{count} line(s) still need lot / expiry.',
  },
  detailTabs: {
    chung: 'Overview',
    generalInfo: 'Info',
    chiTietHang: 'Line items',
    soKhop: 'Match',
    lines: 'Received Items',
  },
}
